import { TransactionSourceTypeDto } from './dtos/transactions'
import { match } from '../utils/pattern-match-util'

export const enum TransactionSourceType {
  Unknown,
  User,
  Job,
}

export function parseTransactionSourceType(
  dto: TransactionSourceTypeDto,
): TransactionSourceType {
  switch (dto) {
    case 'USER':
      return TransactionSourceType.User
    case 'JOB':
      return TransactionSourceType.Job
  }
  console.warn('Unknown transaction source type', dto)
  return TransactionSourceType.Unknown
}

export function serializeTransactionSourceType(
  sourceType: TransactionSourceType,
): TransactionSourceTypeDto {
  return match<TransactionSourceType, TransactionSourceTypeDto>(sourceType, {
    [TransactionSourceType.Job]: () => 'JOB',
    [TransactionSourceType.User]: () => 'USER',
    [TransactionSourceType.Unknown]: () => {
      throw new Error(
        `Cannot serialize unknown transaction source type '${sourceType}'`,
      )
    },
  })
}
